import { MessageCircle, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/translations";
import { useState, useEffect } from "react";
import { openWhatsApp, WHATSAPP_MESSAGES } from "@/lib/whatsapp";

interface OpenHouseBannerProps {
  onVisibilityChange?: (isVisible: boolean) => void;
}

export const OpenHouseBanner = ({ onVisibilityChange }: OpenHouseBannerProps) => {
  const location = useLocation();
  const { language } = useLanguage();
  const t = translations[language];
  const [isVisible, setIsVisible] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("openHouseBannerDismissed");
    if (dismissed) {
      setIsVisible(false);
    }
    // Trigger mount animation
    setIsMounted(true);
  }, []);

  useEffect(() => {
    onVisibilityChange?.(isVisible);
  }, [isVisible, onVisibilityChange]);

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsVisible(false);
    localStorage.setItem("openHouseBannerDismissed", "true");
  };

  // No mostrar el banner en las páginas de inscripción a puertas abiertas
  if (
    location.pathname.includes("inscripcion-puertas-abiertas") ||
    location.pathname.includes("open-house-registration") ||
    location.pathname.includes("inscricao-portas-abertas") ||
    location.pathname.includes("inscription-portes-ouvertes")
  ) {
    return null;
  }

  // Verificación de seguridad para las traducciones
  if (!t || !t.openHouse || !t.openHouse.lastSpots || !isVisible) {
    return null;
  }

  return (
    <div
      onClick={() => openWhatsApp(WHATSAPP_MESSAGES.bookVisit[language])}
      className={`fixed top-[80px] left-0 right-0 z-[40] bg-primary text-primary-foreground px-4 cursor-pointer shadow-md border-b border-primary-foreground/10 py-[10px] transition-all duration-300 ${
        isMounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-full"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center justify-center gap-3 flex-1 text-center">
          <MessageCircle className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm md:text-base font-medium">
            {t.openHouse.lastSpots}
          </p>
        </div>
        <button
          onClick={handleDismiss}
          className="p-1 hover:bg-primary-foreground/10 rounded-full transition-colors"
          aria-label="Cerrar banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
